import React from 'react';
import { Row, Col, Spin } from 'antd';
import { Empty, FormTitle, Paging, useBreadcrumbRoutes, usePaging, Wrapper } from '@maxtropy/components';
import { useRequest } from 'ahooks';
import { apiV2DistributionCabinetRoomMonitorPagePost } from '@maxtropy/device-customer-apis-v2';
import MonitorCard from '../components/VideoCard';
import { useParams } from 'react-router-dom';

const ViewVideoList: React.FC = () => {
  const { id } = useParams();
  const breadcrumbRoutes = useBreadcrumbRoutes();

  const pagingInfo = usePaging(10);
  const { pageOffset, pageSize, setTotalCount } = pagingInfo;

  const { data, loading } = useRequest(
    () =>
      apiV2DistributionCabinetRoomMonitorPagePost({ roomId: id, page: pageOffset, size: pageSize }).then(res => {
        setTotalCount(res.total ?? 0);
        return res.list || [];
      }),
    {
      refreshDeps: [pageOffset, pageSize, id],
    }
  );

  return (
    <Wrapper routes={[...(breadcrumbRoutes?.routes ?? []), { name: '查看视频监控' }]}>
      <FormTitle title="查看视频监控" />
      <Spin spinning={loading}>
        <Row gutter={[16, 16]}>
          {(data ?? []).length ? (
            data?.map(item => (
              <Col span={6} key={item.id}>
                <MonitorCard name={item.name!} url={item.url} code={item.code!} />
              </Col>
            ))
          ) : (
            <Empty style={{ textAlign: 'center', margin: '80px auto 0' }} />
          )}
        </Row>
        <Paging pagingInfo={pagingInfo} />
      </Spin>
    </Wrapper>
  );
};

export default ViewVideoList;
